import Api from "~/service/Api";

class CreditCardRepository {
  fetch(query = {}) {
    return Api.get("/credit/cards", query);
  }

  create(data) {
    return Api.post(`/credit/cards`, data);
  }

  delete(creditCardId) {
    return Api.delete(`/credit/cards/${creditCardId}`);
  }
}

export default CreditCardRepository;
